// extracted by mini-css-extract-plugin
module.exports = {"companyLink":"OfficeInfo_companyLink__1mHsl"};